import React, { Component } from 'react';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  DEFAULT_ZIPCODE_CITY_AND_REGION,
  ONLY_NUMBER_REGEX
} from '../../constants/defaults';
import { getIp } from '../../services/Api/SearchBar/SearchBarService';
import './zipcode.scss';
import loadable from '@loadable/component';
const ZipCodeModal = loadable(() => import('./ZipCodeModal'));
class Zipcode extends Component {
  state = {
    locationZip: '',
    invalidLocation: false,
    locationDropdown: false,
    isZipCodeModal: false
  };

  getLocationFromIp = (flag = 0) => {
    const zipCodeData = JSON.parse(localStorage.getItem('zipCodeData'));
    if (!flag && zipCodeData) {
      const { city, state, zipCode } = zipCodeData;
      const locationZip =
        zipCode && ONLY_NUMBER_REGEX.test(zipCode) && zipCode !== '00000'
          ? `${zipCode} - ${city}, ${state}`
          : `${city}, ${state}`;
      this.setState({
        locationZip: locationZip
      });
    } else {
      const location = getIp();
      if (
        location.status &&
        location.status === 200 &&
        location.data.state &&
        location.data.zipCode &&
        location.data.zipCode.length === 5 &&
        location.data.zipCode !== '00000'
      ) {
        localStorage.setItem('zipCodeData', JSON.stringify(location.data));
        const zipCodeData = JSON.parse(localStorage.getItem('zipCodeData'));
        const { city, state, zipCode } = zipCodeData;
        this.setState({
          invalidLocation: false,
          locationZip: zipCode + ' - ' + city + ', ' + state
        });
      } else {
        _.setDefaultLocation();
        this.setState({
          locationZip: DEFAULT_ZIPCODE_CITY_AND_REGION
        });
      }
    }
  };

  async componentDidMount() {
    await this.getLocationFromIp(false);
  }

  componentDidUpdate(prevProps) {
    const zipCodeData = JSON.parse(localStorage.getItem('zipCodeData'));
    if (!_.isEmpty(zipCodeData)) {
      const { city, state, City, Region, zipCode } = zipCodeData;
      let locationZip = '';
      if (ONLY_NUMBER_REGEX.test(zipCode))
        locationZip = `${zipCode} - ${city || City}, ${state || Region}`;
      else locationZip = `${city || City}, ${state || Region}`;
      if (!_.isEqual(this.props.zipCode, prevProps.zipCode)) {
        this.setState({ locationZip: locationZip });
      }
    }
  }

  setZipCode = zipcode => {
    const zipCodeData = JSON.parse(localStorage.getItem('zipCodeData'));
    if (zipCodeData) {
      const { city, state, zipCode } = zipCodeData;
      const locationZip =
        zipCode && ONLY_NUMBER_REGEX.test(zipcode)
          ? `${zipCode} - ${city}, ${state}`
          : `${city}, ${state}`;
      this.setState({
        isZipCodeModal: false,
        locationZip: locationZip
      });
      this.props.handleZipCodeChange(zipcode);
    }
  };

  openZipCodeModal = () => {
    this.setState({ isZipCodeModal: true });
  };
  closeZipCodeModal = () => {
    this.setState({ isZipCodeModal: false });
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.isZipCodeModal === !nextState.isZipCodeModal) {
      document.body.style.overflow = nextState.isZipCodeModal ? 'hidden' : '';
    }
    return true;
  }

  render() {
    const { t } = this.props;
    return (
      <div className="zipCodeSection">
        <div className="input-icon-wrap">
          <div
            className="locationDropdownContainer"
            role="button"
            aria-label={t('Enter Location')}
            aria-haspopup="dialog"
            aria-modal={this.state.isZipCodeModal ? true : false}
          >
            <div
              className={`${
                this.state.invalidLocation ? 'inputError' : ''
              } locationInputDropdownContainer`}
            >
              <span className="input-icon">
                <span className="mapIcon"></span>
              </span>
              <form
                className="locationForm"
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    this.openZipCodeModal();
                  }
                }}
              >
                <input
                  type="text"
                  id="zipValue"
                  maxLength="5"
                  className="locationInput nocursor themeFocus"
                  placeholder="Search location"
                  onClick={() => this.openZipCodeModal()}
                  defaultValue={this.state.locationZip}
                  autoComplete="off"
                  aria-label="Search location"
                />
                <div
                  className="zipCodeButton themeFocus"
                  aria-label="Search location"
                  id="zipValueMobile"
                  onClick={() => this.openZipCodeModal()}
                  tabIndex={0}
                >
                  <span className="pinkMark">
                    <span className="mapIcon"></span>
                  </span>
                  <span className="locationZipLabel">
                    {this.state.locationZip}
                  </span>
                  <span className="tooltip">
                    <i className="arrowUp"></i>
                    <span>{t('Set your location')}</span>
                  </span>
                </div>
              </form>
            </div>
          </div>
        </div>
        {this.state.isZipCodeModal && (
          <ZipCodeModal
            setZipCode={this.setZipCode}
            hideZipCodeModal={() => this.closeZipCodeModal()}
            isZipCodeModal={this.state.isZipCodeModal}
          />
        )}
      </div>
    );
  }
}

Zipcode.propTypes = {
  setZipCode: PropTypes.func
};

Zipcode.defaultProps = {
  setZipCode: () => {}
};

export default withTranslation()(Zipcode);
